import {useForm} from 'react-hook-form';
import {useId} from 'react';
import {User} from '../../../user';
import {AccountSettingsPanel} from '../account-settings-panel';
import {Button} from '@common/ui/buttons/button';
import {Form} from '@common/ui/forms/form';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {useUpdateAccountDetails} from './update-account-details';
import {Trans} from '@common/i18n/trans';
import {useUploadAvatar} from '../avatar/upload-avatar';
import {useRemoveAvatar} from '../avatar/remove-avatar';
import {FormImageSelector} from '@common/ui/images/image-selector';
import {FileUploadProvider} from '@common/uploads/uploader/file-upload-provider';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
import React, { useState } from 'react';




interface Props {
  user: User;
}
export function BasicInfoPanel({user}: Props) {
  const uploadAvatar = useUploadAvatar({user});
  const removeAvatar = useRemoveAvatar({user});
  const formId = useId();
  const form = useForm<Partial<Omit<User, 'subscriptions'>>>({
    defaultValues: {
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      avatar: user.avatar,
    },
  });
  const updateDetails = useUpdateAccountDetails(form);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };




  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const handleOpenModal2 = () => {
    setIsModalOpen2(true);
  };

  const handleCloseModal2 = () => {
    setIsModalOpen2(false);
  };

  return (
    <AccountSettingsPanel
      id={AccountSettingsId.AccountDetails}
      title={<Trans message="" />}
      // actions={
      //   <Button
      //     type="submit"
      //     variant="flat"
      //     color="primary"
      //     form={formId}
      //     disabled={updateDetails.isPending || !form.formState.isValid}
      //   >
      //     <Trans message="Kaydet" />
      //   </Button>
      // }
    >
      <Form
        form={form}
        className="flex flex-col items-center gap-10 md:gap-30"
        onSubmit={newDetails => {
          updateDetails.mutate(newDetails);
        }}
        id={formId}
      >

        <div className='accountframe'>
          <div className='accountframeInside'>
              <div className='accountframeInsideTitle'><Trans message="Name" /> </div>
              <div className='accountframeInsideText' id='accountframeInsideFirstName'>*****</div>
          </div>
      
      <button type='button' onClick={handleOpenModal} className='accountframeInsideButton'><Trans message="Edit" /> </button>
      <dialog open={isModalOpen} className="modal">
        <div className="modal-content">
          <span className="close" onClick={handleCloseModal}>&times;</span>
          <h2 className='modal_dialog_title'><Trans message="Name" /> </h2>
          <div className="flex-auto w-full">
          <FormTextField
            className="mb-24 modal_dialog_form_element"
            name="first_name"
            label={<Trans message="Name" />}
            placeholder='Profilinde görüntülenmesini istediğin ismi yaz. Bu alanı sadece sen görüntüleyeceksin.'
          />
          <button className='modal_dialog_save_button'><Trans message="Save" /> </button>          
        </div>
        </div>
      </dialog>
      
        </div>

        <div className='accountframe'>
          <div className='accountframeInside'>
              <div className='accountframeInsideTitle'>
                Email
                <label id='email_verify_area'>
                </label>
              </div>
              <div className='accountframeInsideText' id='accountframeInsideEmail'>*****@*****.com</div>
          </div>
          <button type='button' onClick={handleOpenModal2} className='accountframeInsideButton'><Trans message="Edit" /> </button>
      <dialog open={isModalOpen2} className="modal">
        <div className="modal-content">
          <span className="close" onClick={handleCloseModal2}>&times;</span>
          <h2 className='modal_dialog_title'>Email</h2>
          <div className="flex-auto w-full">
          {/* <FormTextField
            className="mb-24 modal_dialog_form_element email_disabled_input_popup"
            name="email"
            label={<Trans message="Email adresi" />}
            placeholder='Email'
            disabled
          /> */}
          <br></br>
          <h4 id='pop_up_input_field_area'></h4><br></br>
          <p><Trans message="Mail adresi güncellemesi sistemsel olarak yapılamamaktadır. Dilerseniz geçerli hesabınızı silebilir, güncel adresinizle yeni hesap açılışı yapabilirsiniz. Anlayışınız için teşekkür ederiz." /></p><br></br>
          {/* <button className='modal_dialog_save_button_disabled' disabled>Kaydet</button>           */}
        </div>
        </div>
      </dialog>
        </div>

        {/* 

       
        
        

   

        <div className='accountframe'>
          <div className='accountframeInside'>
              <div className='accountframeInsideTitle'>Hesabı sil</div>
              <p className='acccountframeParag'>Bu hesabı kalıcı olarak silmek için bu seçeneği seç. Hesap silindiğinde kullanılan tüm sayfalar da kalıcı olarak silinecektir.</p>
          </div>
        </div>
        <button className='acccountframeDeleteAccountButton' type='button'>Hesabı sil</button>
 */}

       

        {/* <div className="flex-auto w-full">
          <FormTextField
            className="mb-24"
            name="first_name"
            label={<Trans message="İsim" />}
          />
          <FormTextField
            name="last_name"
            label={<Trans message="Soyisim" />}
          />
        </div> */}

        {/* <FileUploadProvider>
          <FormImageSelector
            className="md:mr-80"
            variant="avatar"
            previewSize="w-90 h-90"
            showRemoveButton
            name="avatar"
            diskPrefix="avatars"
            label={<Trans message="Profile image" />}
            onChange={url => {
              if (url) {
                uploadAvatar.mutate({url});
              } else {
                removeAvatar.mutate();
              }
            }}
          />
        </FileUploadProvider> */}
      </Form>
    </AccountSettingsPanel>
  );
}
